import React from 'react';
import aboutImage from '../assests/img/about-us-home.png';

function WhyParticipate() {
  return (
    <section className="ma-why-participate" aria-labelledby="why-participate-title">
      <div className="ma-container">
        <div className="ma-why-participate-header">
          <span className="ma-why-participate-icon" aria-hidden="true">
            ?
          </span>
          <h2 id="why-participate-title" className="ma-why-participate-title">
            Why Participate?
          </h2>
          <p className="ma-why-participate-text">
            Experience a high-octane business environment at{' '}
            <strong>Bharat Mandapam, Pragati Maidan, New Delhi</strong>, from{' '}
            <strong>August 8th to 10th, 2026</strong>. This world-class venue provides the
            perfect backdrop for large-scale networking and premium brand showcasing.
          </p>
        </div>

        <div className="ma-why-participate-visual">
          <div className="ma-why-participate-visual-bg" aria-hidden="true" />
          <img
            className="ma-why-participate-img"
            src={aboutImage}
            alt="MobileAcc Expo exhibition showcase with mobile devices and attendees"
          />
        </div>
      </div>
    </section>
  );
}

export default WhyParticipate;
